import { Injectable } from '@angular/core';
import { HomesFacade } from '@library/store/homes/homes.facade';
import { ModulesFacade } from '@library/store/modules/modules.facade';
import { Module } from '@library/store/modules/modules.interface';
import { Room } from '@library/store/rooms/rooms.interface';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { RoomTemperatureService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/sidebar-rooms/sidebar-room-card/room-temperature/room-temperature.service';
import { SidebarRoomService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/sidebar-rooms/sidebar-room-card/sidebar-room.service';
import { combineLatest, map, switchMap } from 'rxjs';

@Injectable()
export class BoilerIconService {

  boilerOn$ = this.roomTemperatureService.module$.pipe(
    isDefined(),
    switchMap(module => combineLatest({
      homeThermostats: this.homesFacade.homeThermostats$,
      roomRelay: this.modulesFacade.getModulesById([module.bridge]).pipe(
        map(modules => modules[0] ?? module)
      ),
      room: this.sidebarRoomService.room$,
    })),
    map(({homeThermostats, roomRelay, room}) => this.boilerOn(homeThermostats, roomRelay, room)),
  );

  constructor(
    public sidebarRoomService: SidebarRoomService,
    private homesFacade: HomesFacade,
    private modulesFacade: ModulesFacade,
    private roomTemperatureService: RoomTemperatureService,
  ) {}

  private boilerOn(homeThermostats: Module[], roomRelay: Module, room: Room) {
    const roomThermostat = homeThermostats.find(thermostat => thermostat.room_id === room.id);
    if (roomThermostat) {
      return roomThermostat.boiler_status == true;
    }
    else if (roomRelay.boiler_status != null) {
      return (room.hasValves && (room.heating_power_request > 0) && roomRelay.boiler_status)
            || (!room.hasValves && roomRelay.boiler_status);
    }
    else {
      return room.heating_power_request > 0;
    }
  }

}